
import { supabase } from '@/integrations/supabase/client';
import { EmailTemplateType, getEmailTemplate } from '@/utils/email-templates';
import type { EmailTemplateProps } from '@/utils/email-templates';

export async function sendNotification(
  type: EmailTemplateType,
  recipientEmail: string,
  templateProps: EmailTemplateProps,
  fromAddress?: string
) {
  console.log('sendNotification called with:', { 
    type, 
    recipientEmail, 
    templateProps: Object.keys(templateProps),
    fromAddress 
  });
  
  try {
    console.log('Sending notification via send-notification edge function');

    // Prepare headers to include origin information for environment-aware URLs
    const headers: Record<string, string> = {};
    
    // Include current origin if available
    if (typeof window !== 'undefined') {
      headers['origin'] = window.location.origin;
      headers['referer'] = window.location.href;
    }

    // Send the notification using the centralized send-notification function
    const { data, error } = await supabase.functions.invoke('send-notification', {
      body: {
        type,
        recipientEmail,
        templateProps
      },
      headers
    });

    if (error) {
      console.error('Error sending notification:', error);
      throw error;
    }

    console.log('Notification sent successfully:', data);
    return data;
  } catch (error) {
    console.error('Failed to send notification:', error);
    throw error;
  }
}
